const paths = {
  listDivision: '/division/list',
  editDivision: '/division/edit'
};

export default paths;
